module.exports = __webpack_public_path__ + "img/fourthSpecialities.b5ae20ec.png";